// ══════════════════════════════════════════════════════════════════════════════════════════════
//  EL DÍA DE HOY DE LA CLÍNICA, EN SU ZONA  (5-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  EL FALLO: `new Date().toISOString().split('T')[0]` es el día en UTC. Entre las 00:00 y las 02:00 de Madrid (la 01:00
//  en invierno) UTC va todavía por el día anterior: la pantalla de Recordatorios abría en AYER, con las citas de ayer
//  listas para recordar, y lo mismo el botón «Hoy» de Recalls, el periodo de las métricas de LucIA, la casilla de hoy del
//  calendario de campañas y la hora de una campaña programada al editarla.
//
//  LO QUE DA: el día (y la hora) de un instante —por defecto, ahora— en la zona horaria de LA CLÍNICA: la que cargó la
//  configuración regional en esta sesión (context/RegionalContext la apunta aquí con `fijarZonaDeLaClinica`), si no la
//  última guardada en este navegador, y si no Europe/Madrid (el mismo defecto de services/formatos). Es la misma cuenta que
//  `f.hoy()` / `f.ahora()` de useRegional(), para donde no se puede usar un hook: el valor inicial de un useState, un
//  manejador, un efecto, el nombre de un fichero que se descarga.
//
//  SIN IMPORTS A PROPÓSITO: un `utils/` sin dependencias lo cargan de verdad las guardias que montan una pantalla, y así
//  meterlo en una pantalla no obliga a tocar cada guardia que la monta.
const ZONA_DEFECTO = 'Europe/Madrid'
let _zonaSesion = null

const _valida = (z) => {
  if (typeof z !== 'string' || !z.trim()) return false
  try { new Intl.DateTimeFormat('en-US', { timeZone: z.trim() }); return true } catch { return false }
}

/** Lo llama la configuración regional al cargarla (y con null al cerrar sesión). */
export function fijarZonaDeLaClinica(zona) {
  _zonaSesion = _valida(zona) ? zona.trim() : null
}

/** La zona con la que se cuenta ahora mismo. */
export function zonaDeLaClinica() {
  if (_zonaSesion) return _zonaSesion
  try {
    const clave = 'regional_cache:' + (typeof location !== 'undefined' ? location.host : 'app')
    const v = JSON.parse(localStorage.getItem(clave) || 'null')
    if (v && _valida(v.zona_horaria)) return v.zona_horaria.trim()
  } catch { /* sin almacenamiento (incógnito, una prueba): el defecto */ }
  return ZONA_DEFECTO
}

function _partes(instante) {
  const fecha = instante instanceof Date ? instante : (instante != null ? new Date(instante) : new Date())
  const p = {}
  const fmt = new Intl.DateTimeFormat('en-US', { timeZone: zonaDeLaClinica(), year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
  for (const t of fmt.formatToParts(fecha)) if (t.type !== 'literal') p[t.type] = t.value
  return { ...p, hour: p.hour === '24' ? '00' : p.hour }
}

/** 'YYYY-MM-DD' de ese instante (o de ahora) en la clínica. */
export function hoyDeLaClinica(instante) {
  const p = _partes(instante)
  return `${p.year}-${p.month}-${p.day}`
}

/**
 * El DÍA en la clínica de un instante que llega del servidor (el `created_at` de un mensaje: un ISO en UTC, «…T22:30:00Z»).
 * `String(created_at).slice(0, 10)` es su día en UTC, y un mensaje de las 0:30 de Madrid quedaba con fecha de AYER
 * (8-oct-2026). Un 'YYYY-MM-DD' suelto ya es un día y se devuelve tal cual; sin nada válido, hoy.
 */
export function diaDeLaClinica(valor) {
  if (typeof valor === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(valor.trim())) return valor.trim()
  const d = valor instanceof Date ? valor : (valor != null && valor !== '' ? new Date(valor) : null)
  return d && !Number.isNaN(d.getTime()) ? hoyDeLaClinica(d) : hoyDeLaClinica()
}

/** 'YYYY-MM-DDTHH:MM' de ese instante (o de ahora) en la clínica: lo que pide un <input type="datetime-local">. */
export function ahoraDeLaClinica(instante) {
  const p = _partes(instante)
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`
}
